import {
    Box,
    Avatar,
    InputBase,
    IconButton,
    Badge,
    Select,
    MenuItem,
    FormControl,
    Chip,
    CircularProgress,
    Typography,
    Divider,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Skeleton,
    Tooltip,
  } from "@mui/material";
  import { useState, useEffect, useRef } from "react";
  import { Send, ArrowDropDown, Close, AttachFile, Image, Description, Download, Add, ArrowBack, InsertDriveFile, CheckCircle, DoneAll, FiberManualRecord } from "@mui/icons-material";
  import SearchIcon from "@mui/icons-material/Search";
  import CustomText, { textStyles } from "../../../../components/CustomText";
  import chatimage from "../../../../assets/chatimage.jpeg";
  import { useTranslation } from "react-i18next";
  import { useSelector } from "react-redux";
  import { decryptToken } from "../../../../Utlis/Encryption.js";
  import { BASE_URL, URL } from "../../../../components/BaseUrl.js";
  import { io } from "socket.io-client";
  // Removed Redux imports - using local state only for counts
  
  const SuperAdminMessages = () => {
    const { t } = useTranslation();
  
    const [chatList, setChatList] = useState([]);
    const [selectedChat, setSelectedChat] = useState(null);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");
    const [otherUserInfo, setOtherUserInfo] = useState(null);
    const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
    const [isUploadingImage, setIsUploadingImage] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [selectedImageFile, setSelectedImageFile] = useState(null);
    const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
    const [isUploadingFile, setIsUploadingFile] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSuperAdminList, setShowSuperAdminList] = useState(false);
  const [superAdmins, setSuperAdmins] = useState([]);
  const [isLoadingSuperAdmins, setIsLoadingSuperAdmins] = useState(false);
  const [showThreads, setShowThreads] = useState(false);
  const [isCreatingThread, setIsCreatingThread] = useState(false);
  
  // New state for WhatsApp-like functionality
  const [userOnlineStatus, setUserOnlineStatus] = useState({});
  const [messageDeliveryStatus, setMessageDeliveryStatus] = useState({});
  const [unreadCounts, setUnreadCounts] = useState({});
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);
  const [detailedUnreadCounts, setDetailedUnreadCounts] = useState([]);
  
  const { company, user } = useSelector((state) => state.auth);
  // Remove Redux dependency for counts - use local state only
    
    // Debug: Log count changes
    useEffect(() => {
      console.log("🔢 Total Unread Count updated:", totalUnreadCount);
    }, [totalUnreadCount]);
    
    // Debug: Log user information
    useEffect(() => {
      console.log("👤 User information:", user);
      console.log("👤 User name options:", {
        name: user?.name,
        username: user?.username,
        first_name: user?.first_name,
        last_name: user?.last_name
      });
    }, [user]);

    // Debug: Log other user information
    useEffect(() => {
      console.log("👥 Other user information:", otherUserInfo);
      console.log("👥 Other user name options:", {
        name: otherUserInfo?.name,
        email: otherUserInfo?.email,
        role: otherUserInfo?.role,
        profile_image: otherUserInfo?.profile_image
      });
    }, [otherUserInfo]);

    // Function to set other user information from thread data
    const setOtherUserFromThreadData = (threadData) => {
      console.log("👤 Thread data received:", threadData);
      
      // Determine which user is the "other" user based on current user's role
      const currentUserId = socketUserId || userId;
      const isCurrentUserSuperAdmin = threadData.super_admin?.id === currentUserId;
      
      if (isCurrentUserSuperAdmin) {
        // Current user is super admin, so other user is participant
        setOtherUserInfo(threadData.participant);
        console.log("👥 Other user (participant):", threadData.participant);
      } else {
        // Current user is participant, so other user is super admin
        setOtherUserInfo(threadData.super_admin);
        console.log("👥 Other user (super admin):", threadData.super_admin);
      }
    };
    const companyId = company?.id;
  
    const token = useSelector((state) => state.auth.token);
    const decryptedToken = token ? decryptToken(token) : null;
  
    // Extract logged-in user id from JWT
    const userId = decryptedToken
      ? JSON.parse(atob(decryptedToken.split(".")[1])).id
      : null;
  
    const [socket, setSocket] = useState(null);
    const [socketUserId, setSocketUserId] = useState(null);
    const selectedChatRef = useRef(null);
    const messagesEndRef = useRef(null);
  
    useEffect(() => {
      selectedChatRef.current = selectedChat;
    }, [selectedChat]);

    // Auto-scroll to bottom when messages change
    useEffect(() => {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, [messages]);
  
    // Function to format time consistently with UTC handling
    const formatThreadTime = (dbTimestamp) => {
      try {
        // Parse the UTC timestamp
        const messageDate = new Date(dbTimestamp);
        
        if (isNaN(messageDate.getTime())) {
          console.warn("Invalid timestamp:", dbTimestamp);
          return t('invalid_time');
        }
        
        // Get the current time to compare
        const now = new Date();
        const timeDiff = Math.abs(now.getTime() - messageDate.getTime());
        
        // If the message is very recent (within 1 minute), show current time
        if (timeDiff < 60000) { // 1 minute = 60000ms
          const currentTime = now.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          });
          console.log("Using current time for recent message:", { dbTimestamp, currentTime });
          return currentTime;
        }
        
        // For older messages, use direct timezone conversion
        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        
        // Use toLocaleTimeString with timezone directly
        const formatted = messageDate.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
          timeZone: userTimezone
        });
        
        return formatted;
      } catch (error) {
        return t('error');
      }
    };

    // Helper function to get message delivery status icon
    const getMessageStatusIcon = (status, isOwn, message) => {
      if (!isOwn) return null;
      
      // Only show read status if the OTHER user has read the message
      // Don't show read status when current user (super admin) reads their own message
      const currentUserId = socketUserId || userId;
      const isCurrentUserSuperAdmin = user?.role === 'super_admin';
      
      // If current user is super admin and they read a message, don't show read status
      if (isCurrentUserSuperAdmin && message?.read_by_super_admin) {
        return <DoneAll sx={{ fontSize: 14, color: '#666' }} />; // Show delivered only
      }

      console.log("👁️ Message status:", status);
      switch(status) {

        case 'sent':
          return <CheckCircle sx={{ fontSize: 14, color: '#666' }} />;
        case 'delivered':
          return <DoneAll sx={{ fontSize: 14, color: '#666' }} />;
        case 'read':
          // Only show blue checkmarks if the OTHER user read it
          return <DoneAll sx={{ fontSize: 14, color: '#006EC2' }} />;
        default:
          return <CheckCircle sx={{ fontSize: 14, color: '#666' }} />;
      }
    };

    // Helper function to format last seen time
    const formatLastSeen = (lastSeenAt) => {
      if (!lastSeenAt) return t('never');
      
      const lastSeen = new Date(lastSeenAt);
      const now = new Date();
      const diffMs = now - lastSeen;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);
      
      if (diffMins < 1) return t('just_now');
      if (diffMins < 60) return t('minutes_ago', { count: diffMins });
      if (diffHours < 24) return t('hours_ago', { count: diffHours });
      if (diffDays < 7) return t('days_ago', { count: diffDays });
      
      return lastSeen.toLocaleDateString();
    };

    // Helper function to get online status indicator
    const getOnlineStatusIndicator = (userId) => {
      const status = userOnlineStatus[userId];
      if (!status) return null;
      
      if (status.isOnline) {
        return (
          <Tooltip title={t('online')}>
            <FiberManualRecord sx={{ fontSize: 12, color: '#4CAF50' }} />
          </Tooltip>
        );
      } else {
        return (
          <Tooltip title={`${t('last_seen')} ${formatLastSeen(status.lastSeenAt)}`}>
            <FiberManualRecord sx={{ fontSize: 12, color: '#9E9E9E' }} />
          </Tooltip>
        );
      }
    };

    // Helper function to get unread count display
    const getUnreadCountDisplay = (count) => {
      if (count === 0) return null;
      if (count > 99) return '99+';
      return count.toString();
    };
  
  // Scroll functionality removed as per user request
  
    // Helper functions for socket event handlers
    const updateSuperAdminChatUI = (data) => {
      console.log("📱 Updating Super Admin chat UI:", data);
      // This function can be expanded to handle specific UI updates
    };
  
    // Typing indicators removed as per user request
  
    const updateReadStatus = (data) => {
      console.log("👁️ Updating read status:", data);
      // Implement read status updates here
    };
  
    // Mark messages as read via socket only
    const markMessagesAsRead = async (threadId) => {
      try {
        if (socket && socket.connected) {
          console.log("📤 Emitting mark_super_admin_read for thread:", threadId);
          socket.emit("mark_super_admin_read", {
            threadId: threadId,
          });
        } else {
          console.log("⚠️ Socket not connected, cannot mark messages as read");
        }
      } catch (error) {
        console.error("Error marking messages as read:", error);
      }
    };

    // Image upload function
    const uploadImage = async (file) => {
      const formData = new FormData();
      formData.append("image", file);
      
      const response = await fetch(`${URL}/api/upload/image`, {
        method: "POST",
        headers: { Authorization: `Bearer ${decryptedToken}` },
        body: formData,
      });
      
      const result = await response.json();
      
      if (!result.error && result.data?.url) {
        return result.data.url;
      } else {
        throw new Error(result.message || "Image upload failed");
      }
    };

    // File upload function for PDF/Word documents
    const uploadFile = async (file) => {
      console.log("📤 Starting file upload:", { fileName: file.name, fileSize: file.size, fileType: file.type });
      
      const formData = new FormData();
      formData.append("pdf", file);
      
      console.log("📤 Uploading to:", `${URL}/api/upload/pdf`);
      
      const response = await fetch(`${URL}/api/upload/pdf`, {
        method: "POST",
        headers: { Authorization: `Bearer ${decryptedToken}` },
        body: formData,
      });
      
      console.log("📤 Upload response status:", response.status);
      
      const result = await response.json();
      console.log("📤 Upload response data:", result);
      
      if (!result.error && result.data?.url) {
        console.log("✅ File upload successful, URL:", result.data.url);
        return result.data.url;
      } else if (!result.error && result.url) {
        console.log("✅ File upload successful (alternative URL format), URL:", result.url);
        return result.url;
      } else {
        console.error("❌ File upload failed:", result);
        console.error("❌ Response structure:", { error: result.error, data: result.data, url: result.url });
        throw new Error(result.message || "File upload failed");
      }
    };

    // Handle file selection (both images and documents)
    const handleFileSelect = async (event) => {
      const file = event.target.files[0];
      if (file) {
        const isImage = file.type.startsWith('image/');
        const isDocument = [
          'application/pdf', 
          'application/msword', 
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'text/plain',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.ms-powerpoint',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        ].includes(file.type);
        
        // Validate file type
        if (!isImage && !isDocument) {
          alert(t("Please select an image, PDF, or Word document"));
          return;
        }
        
        // Validate file size
        const maxSize = isImage ? 5 * 1024 * 1024 : 10 * 1024 * 1024; // 5MB for images, 10MB for documents
        if (file.size > maxSize) {
          alert(t(isImage ? "Image size should be less than 5MB" : "File size should be less than 10MB"));
          return;
        }
        
        if (isImage) {
          // Handle image upload
          setSelectedImageFile(file);
          
          // Create preview
          const reader = new FileReader();
          reader.onload = (e) => {
            setImagePreview(e.target.result);
          };
          reader.readAsDataURL(file);
          
          // Auto-upload image
          setIsUploadingImage(true);
          try {
            const imageUrl = await uploadImage(file);
            setUploadedImageUrl(imageUrl);
            console.log("✅ Image uploaded successfully:", imageUrl);
          } catch (error) {
            console.error("❌ Image upload failed:", error);
            alert(t("Image upload failed. Please try again."));
            setImagePreview(null);
            setSelectedImageFile(null);
          } finally {
            setIsUploadingImage(false);
            event.target.value = '';
          }
        } else {
          // Handle document upload
          console.log("📄 Processing document file:", { name: file.name, type: file.type, size: file.size });
          setSelectedFile(file);
          
          // Auto-upload file
          setIsUploadingFile(true);
          try {
            const fileUrl = await uploadFile(file);
            console.log("📄 Setting uploaded file URL:", fileUrl);
            setUploadedFileUrl(fileUrl);
           
            // Verify state was set
            setTimeout(() => {
              console.log("📄 State verification - uploadedFileUrl:", uploadedFileUrl);
            }, 100);
          } catch (error) {
            console.error("❌ File upload failed:", error);
            alert(t("File upload failed. Please try again."));
            setSelectedFile(null);
          } finally {
            setIsUploadingFile(false);
            event.target.value = '';
          }
        }
      }
    };

    // Clear uploaded image and preview
    const clearUploadedImage = () => {
      setUploadedImageUrl(null);
      setImagePreview(null);
      setSelectedImageFile(null);
    };

    // Clear uploaded file
    const clearUploadedFile = () => {
      setUploadedFileUrl(null);
      setSelectedFile(null);
    };

    // Download file function
    const downloadFile = async (fileUrl, fileName) => {
      try {
        const response = await fetch(fileUrl, {
          headers: { Authorization: `Bearer ${decryptedToken}` },
        });
        
        if (!response.ok) {
          throw new Error('Download failed');
        }
        
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'document';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading file:', error);
        alert(t('Download failed. Please try again.'));
      }
    };

    // Fetch super admins
    const fetchSuperAdmins = async () => {
      setIsLoadingSuperAdmins(true);
      try {
        const res = await fetch(`${URL}/api/super-admin/profile`, {
          method: "GET",
          headers: { Authorization: `Bearer ${decryptedToken}` },
        });
        const data = await res.json();
        console.log("Super admins response:", data);
        
        if (!data.error && Array.isArray(data.data?.super_admins)) {
          // Filter out current user from the list
          const filteredSuperAdmins = data.data.super_admins.filter(
            admin => admin.id !== (socketUserId || userId)
          );
          setSuperAdmins(filteredSuperAdmins);
        }
      } catch (err) {
        console.error("❌ Error fetching super admins:", err);
      } finally {
        setIsLoadingSuperAdmins(false);
      }
    };

    // Fetch total unread count
    const fetchTotalUnreadCount = async () => {
      try {
        const res = await fetch(`${URL}/api/super-admin-chat/unread-count`, {
          method: "GET",
          headers: { Authorization: `Bearer ${decryptedToken}` },
        });
        const data = await res.json();
        
        if (!data.error && data.data?.totalUnread !== undefined) {
          setTotalUnreadCount(data.data.totalUnread);
        }
      } catch (err) {
        console.error("❌ Error fetching total unread count:", err);
      }
    };

    // Fetch detailed unread counts
    const fetchDetailedUnreadCounts = async () => {
      try {
        const res = await fetch(`${URL}/api/super-admin-chat/unread-counts/detailed`, {
          method: "GET",
          headers: { Authorization: `Bearer ${decryptedToken}` },
        });
        const data = await res.json();
        
        if (!data.error && data.data) {
          setDetailedUnreadCounts(data.data.threadCounts || []);
          setTotalUnreadCount(data.data.totalUnread || 0);
          
          // Update local unread counts
          const threadCountsObj = {};
          data.data.threadCounts?.forEach(thread => {
            threadCountsObj[thread.threadId] = thread.unreadCount;
          });
          setUnreadCounts(threadCountsObj);
        }
      } catch (err) {
        console.error("❌ Error fetching detailed unread counts:", err);
      }
    };

    // Fetch user online status
    const fetchUserOnlineStatus = async (userId) => {
      try {
        const res = await fetch(`${URL}/api/super-admin-chat/users/${userId}/status`, {
          method: "GET",
          headers: { Authorization: `Bearer ${decryptedToken}` },
        });
        const data = await res.json();
        
        if (!data.error && data.data) {
          setUserOnlineStatus(prev => ({
            ...prev,
            [userId]: data.data
          }));
        }
      } catch (err) {
        console.error("❌ Error fetching user online status:", err);
      }
    };

    // Mark all messages as read
    const markAllMessagesAsRead = async () => {
      try {
        const res = await fetch(`${URL}/api/super-admin-chat/messages/mark-all-read`, {
          method: "PUT",
          headers: { Authorization: `Bearer ${decryptedToken}` },
        });
        const data = await res.json();
        
        if (!data.error) {
          setTotalUnreadCount(0);
          setDetailedUnreadCounts([]);
          setUnreadCounts({});
        }
      } catch (err) {
        console.error("❌ Error marking all messages as read:", err);
      }
    };

    // Start new chat with super admin
    const startNewChat = async (superAdmin) => {
      // Check if thread already exists with this super admin
      const existingThread = chatList.find((c) => c.other_user_id === superAdmin.id);
      if (existingThread) {
        console.log("Thread already exists with this super admin:", existingThread);
        setShowSuperAdminList(false);
        setSelectedChat(existingThread);
        return;
      }

      setShowSuperAdminList(false);
      setMessages([]);
      setIsCreatingThread(true);

      try {
        // Create thread first before showing it in the UI
        const res = await fetch(`${URL}/api/super-admin-chat/threads`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            receiverId: superAdmin.id,
            receiverRole: "super_admin",
          }),
        });

        const data = await res.json();
        console.log("Thread creation response:", data);

        if (!data.error && data.data?.thread) {
          const thread = data.data.thread;
          console.log("Thread data:", thread);

          const confirmedThread = {
            id: thread.id,
            name: superAdmin.name,
            lastMessage: t('new_conversation_started'),
            avatar: superAdmin.profile_image || "",
            other_user_id: superAdmin.id,
            created_at: thread.created_at || new Date().toISOString(),
            lastMessageAt: thread.created_at || new Date().toISOString(),
            messageIcon: null,
          };

          console.log("Confirmed thread:", confirmedThread);

          // Check if this thread already exists in our list
          const existingThread = chatList.find((c) => c.id === confirmedThread.id);
          if (existingThread) {
            console.log("Thread already exists, just selecting it");
            setSelectedChat(confirmedThread);
            return;
          }

          setChatList((prev) => {
            console.log("Previous chat list:", prev);

            // Check if the confirmed thread already exists by ID or other_user_id
            const existsById = prev.some((c) => c.id === confirmedThread.id);
            const existsByUserId = prev.some((c) => c.other_user_id === confirmedThread.other_user_id);
            console.log("Thread exists by ID:", existsById, "by user ID:", existsByUserId);

            if (existsById) {
              // Update existing thread by ID
              const updated = prev.map((c) =>
                c.id === confirmedThread.id ? confirmedThread : c
              );
              console.log("Updated existing thread by ID:", updated);
              return updated;
            } else if (existsByUserId) {
              // Update existing thread by user ID
              const updated = prev.map((c) =>
                c.other_user_id === confirmedThread.other_user_id ? confirmedThread : c
              );
              console.log("Updated existing thread by user ID:", updated);
              return updated;
            } else {
              // Add new thread
              const newList = [confirmedThread, ...prev];
              console.log("Added new thread:", newList);
              return newList;
            }
          });

          setSelectedChat(confirmedThread);
        } else {
          console.error("❌ Thread creation failed", data);
          alert(t("Failed to create chat. Please try again."));
        }
      } catch (err) {
        console.error("❌ Error starting chat:", err);
        alert(t("Failed to create chat. Please try again."));
      } finally {
        setIsCreatingThread(false);
      }
    };
  
  
  
  
  
  
  
    // Initialize socket only once
    useEffect(() => {
      if (!decryptedToken) {
        console.log("❌ No token available for socket connection");
        return;
      }
  
      console.log("🔌 Initializing socket connection...");
      console.log("🌐 Socket URL:", BASE_URL);
      console.log("🌐 API URL:", URL);
      console.log("🔑 Token available:", !!decryptedToken);
      
      const newSocket = io(`${URL}/`, {
        transports: ["websocket"], 
        autoConnect: true,
        timeout: 20000,
        forceNew: true
      });
      
      console.log("🔌 Socket instance created:", newSocket);
  
      // Keep latest selectedChat
      const handleIncoming = (data, evt) => {
        console.log(`📩 Socket Event [${evt}] received:`, {
          event: evt,
          data: data,
          timestamp: new Date().toISOString()
        });
  
        const newMsg = data.message || data;
        const threadId = data.threadId || data.thread_id;
        
        console.log("🔍 Message details:", {
          message: newMsg,
          threadId: threadId,
          currentChatId: selectedChatRef.current?.id,
          isCurrentChat: selectedChatRef.current && String(threadId) === String(selectedChatRef.current.id)
        });
  
        // Update right-side chat if it's the current one (avoid duplicates)
        if (selectedChatRef.current && String(threadId) === String(selectedChatRef.current.id)) {
          console.log("✅ Adding message to current chat with correct time:", newMsg);
          setMessages((prev) => {
            // Check for duplicates by message ID
            const isDuplicate = prev.some(msg => msg.id === newMsg.id);
            
            if (isDuplicate) {
              console.log("⚠️ Message was a duplicate, not adding:", newMsg);
              return prev;
            }
            
            console.log("📝 Added message with correct server time, total messages:", prev.length + 1);
            const newMessages = [...prev, newMsg];
            // Keep only latest 7 messages
            return newMessages.slice(-7);
          });
        } else {
          console.log("ℹ️ Message not for current chat, updating thread list only");
        }
  
        // Update message counts locally
        const isOwnMessage = newMsg.sender_id === (socketUserId || userId);
        if (isOwnMessage) {
          console.log("📤 Message sent by current user");
        } else {
          console.log("📥 Message received from other user");
        }
  
        // Always update left-side thread list
        setChatList((prev) => {
          const updated = prev.map((c) => {
            if (String(c.id) === String(threadId)) {
              // Format message content for display
              let displayMsg = newMsg.content;
              let messageIcon = null;
              if (newMsg.message_type === "image") {
                // For image messages, show only icon
                displayMsg = "";
                messageIcon = "image";
              } else if (newMsg.message_type === "system" || newMsg.message_type === "file") {
                // For file messages, show only icon
                displayMsg = "";
                messageIcon = "file";
              }
              
              return {
                ...c,
                lastMessage: displayMsg,
                lastMessageAt: newMsg.created_at,
                messageIcon: messageIcon,
              };
            }
            return c;
          });
          
          // Sort threads in descending order (newest first) after update
          const sorted = updated.sort((a, b) => {
            const aTime = new Date(a.lastMessageAt || a.created_at);
            const bTime = new Date(b.lastMessageAt || b.created_at);
            return bTime - aTime; // Descending order
          });
          
          console.log("📋 Updated thread list:", sorted);
          return sorted;
        });
  
      };
  
      ["receive_super_admin_message", "super_admin_message_sent"].forEach(
        (evt) => {
          newSocket.on(evt, (data) => {
            handleIncoming(data, evt);
            updateSuperAdminChatUI(data);
          });
        }
      );
  
      newSocket.on("connect", () => {
        console.log("🔌 Socket connected successfully");
        console.log("🔌 Socket ID:", newSocket.id);
        console.log("🔌 Socket transport:", newSocket.io.engine.transport.name);
        console.log("🔐 Authenticating socket with token...");
        newSocket.emit("super_admin_chat_authenticate", { token: decryptedToken });
      });
  
      newSocket.on("super_admin_chat_authenticated", (data) => {
        console.log("✅ Socket authentication successful:", data);
        if (data.success && data.user) {
          setSocketUserId(data.user.id);
          console.log("🔑 Socket user ID set:", data.user.id);
          // Join super admin chat room after authentication
          newSocket.emit("join_super_admin_chat_room", data.user.id);
        }
      });
  
      // Handle room join confirmation
      newSocket.on("super_admin_chat_room_joined", (data) => {
        console.log("🏠 Successfully joined super admin chat room:", data);
      });
  
      // Handle room join errors
      newSocket.on("super_admin_chat_join_error", (data) => {
        console.error("❌ Failed to join super admin chat room:", data);
      });
  
      // Handle authentication errors
      newSocket.on("super_admin_chat_auth_error", (data) => {
        console.error("❌ Super admin chat authentication error:", data);
      });
  
      newSocket.on("disconnect", (reason) => {
        console.log("❌ Socket disconnected:", reason);
        console.log("❌ Disconnect reason:", reason);
      });
  
      newSocket.on("connect_error", (error) => {
        console.log("❌ Socket connection error:", error);
        console.log("❌ Error details:", {
          message: error.message,
          description: error.description,
          context: error.context,
          type: error.type
        });
      });
  
      newSocket.on("reconnect", (attemptNumber) => {
        console.log("🔄 Socket reconnected after", attemptNumber, "attempts");
      });
  
      newSocket.on("reconnect_attempt", (attemptNumber) => {
        console.log("🔄 Socket reconnection attempt:", attemptNumber);
      });
  
      newSocket.on("reconnect_error", (error) => {
        console.log("❌ Socket reconnection error:", error);
      });
  
      newSocket.on("reconnect_failed", () => {
        console.log("❌ Socket reconnection failed");
      });
  
      // Additional super admin chat event listeners
      newSocket.on("super_admin_messages_read", (data) => {
        console.log("👁️ Messages read:", data);
        updateReadStatus(data);
      });

      // New WhatsApp-like functionality event listeners
      
      // Message delivery status updates
      newSocket.on("super_admin_message_delivery_status", (data) => {
        console.log("📬 Message delivery status update:", data);
        setMessageDeliveryStatus(prev => ({
          ...prev,
          [data.messageId]: {
            status: data.status,
            timestamp: data.timestamp
          }
        }));
      });

      // User status changes (online/offline)
      newSocket.on("super_admin_user_status_change", (data) => {
        console.log("👤 User status change:", data);
        setUserOnlineStatus(prev => ({
          ...prev,
          [data.userId]: {
            isOnline: data.status === 'online',
            lastSeenAt: data.timestamp
          }
        }));
      });

      // Total unread count updates
      newSocket.on("super_admin_total_unread_count_updated", (data) => {
        console.log("🔢 Total unread count updated:", data);
        setTotalUnreadCount(data.totalUnread);
      });

      // Thread unread count updates
      newSocket.on("super_admin_thread_unread_count", (data) => {
        console.log("📋 Thread unread count:", data);
        setUnreadCounts(prev => ({
          ...prev,
          [data.threadId]: data.unreadCount
        }));
      });

      // Detailed unread counts
      newSocket.on("super_admin_detailed_unread_counts", (data) => {
        console.log("📊 Detailed unread counts:", data);
        setDetailedUnreadCounts(data.threadCounts || []);
        setTotalUnreadCount(data.totalUnread || 0);
      });

      // All messages marked as read
      newSocket.on("super_admin_all_messages_marked_read", (data) => {
        console.log("✅ All messages marked as read:", data);
        setTotalUnreadCount(0);
        setDetailedUnreadCounts([]);
        setUnreadCounts({});
      });
  
  
  
      // Handle message sending confirmation
      newSocket.on("super_admin_message_sent", (data) => {
        console.log("✅ Message sent confirmation:", data);
        if (data.success && data.message) {
          // Update messages with server response, avoiding duplicates
          setMessages((prev) => {
            // Check if message already exists
            const exists = prev.some(msg => msg.id === data.message.id);
            if (exists) {
              console.log("⚠️ Message already exists, not adding duplicate");
              return prev;
            }
            
            // Remove any temporary messages and add the real one
            const filtered = prev.filter(msg => msg.tempId !== data.tempId);
            const newMessages = [...filtered, data.message];
            // Keep only latest 7 messages
            return newMessages.slice(-7);
          });
        }
      });
  
      // Handle message sending errors
      newSocket.on("super_admin_message_error", (data) => {
        console.error("❌ Message sending error:", data);
      });
  
      // Handle mark read success
      newSocket.on("super_admin_mark_read_success", (data) => {
        console.log("👁️ Messages marked as read:", data);
      });
  
      // Handle user status changes (online/offline)
      newSocket.on("super_admin_user_status_change", (data) => {
        console.log("👤 User status changed:", data);
        // Update user status in UI if needed
      });
  
      // Handle user statuses list
      newSocket.on("super_admin_user_statuses_list", (data) => {
        console.log("👥 User statuses list:", data);
        // Update user statuses in UI if needed
      });
  
      setSocket(newSocket);
  
      return () => newSocket.disconnect();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [decryptedToken]);
  
    // Fetch Super Admin chat threads
    useEffect(() => {
      const fetchThreads = async () => {
        try {
          // Get all threads for super admin
          const threadRes = await fetch(`${URL}/api/super-admin-chat/threads?page=1&limit=20`, {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
              "Content-Type": "application/json",
            },
          });
          console.log("📋 Threads response:", threadRes);

          if (threadRes.ok) {
            const threadData = await threadRes.json();
            console.log("📋 Threads data:", threadData);
            
            if (!threadData.error && Array.isArray(threadData.data?.threads)) {
              const threads = threadData.data.threads.map((thread) => {
                // Always use current local time for display to avoid server time flash
                const timeToShow = new Date().toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true
                });

                // Set message to "New conversation started" if no last message
                const messageToShow = thread.last_message_content || t('new_conversation_started');

                return {
                  id: thread.id,
                  name: thread.other_user_name,
                  lastMessage: messageToShow,
                  avatar: thread.other_user_avatar || "",
                  other_user_id: thread.other_user_id,
                  created_at: thread.created_at,
                  lastMessageAt: thread.last_message_at,
                  messageIcon: null,
                };
              });

              // Sort threads in descending order (newest first)
              const sortedThreads = threads.sort((a, b) => {
                const aTime = new Date(a.lastMessageAt || a.created_at);
                const bTime = new Date(b.lastMessageAt || b.created_at);
                return bTime - aTime; // Descending order
              });

              // Add delay to prevent server time flash
              setTimeout(() => {
                setChatList(sortedThreads);
                setShowThreads(true);
              }, 100); // 100ms delay
            } else {
              // No threads found, set empty array
              setChatList([]);
              setSelectedChat(null);
              setMessages([]);
            }
          }
        } catch (error) {
          console.error("Error fetching threads:", error);
        }
      };
  
      if (decryptedToken && (socketUserId || userId)) {
        fetchThreads();
      }
    }, [decryptedToken, socketUserId, userId, socket]);

    // Fetch initial unread counts and user statuses
    useEffect(() => {
      if (decryptedToken && socketUserId) {
        // Fetch total unread count
        fetchTotalUnreadCount();
        
        // Fetch detailed unread counts
        fetchDetailedUnreadCounts();
        
        // Request unread counts via socket
        if (socket && socket.connected) {
          socket.emit("get_super_admin_total_unread_count");
          socket.emit("get_super_admin_detailed_unread_counts");
        }
      }
    }, [decryptedToken, socketUserId, socket]);

    // Update online status when socket connects
    useEffect(() => {
      if (socket && socket.connected && socketUserId) {
        // Emit online status update
        socket.emit("update_super_admin_online_status", {
          isOnline: true
        });
      }
    }, [socket, socketUserId]);

    // Fetch messages for a specific thread
    const fetchMessages = async (threadId) => {
      try {
        const res = await fetch(
          `${URL}/api/super-admin-chat/threads/${threadId}/messages?page=1&limit=50`,
          {
            headers: { Authorization: `Bearer ${decryptedToken}` },
          }
        );
        const data = await res.json();
        if (!data.error && data.data?.messages) {
          console.log("📥 Fetched messages:", data.data.messages.length);
          const messages = data.data.messages;
          // Show only latest 7 messages
          const latestMessages = messages.slice(-7);
          setMessages(latestMessages);
        }
      } catch (err) {
        console.error("❌ Error fetching messages:", err);
      }
    };

    // Handle chat selection
    const handleChatClick = (chat) => {
      setSelectedChat(chat);
      fetchMessages(chat.id);

      // Mark messages as read when chat is selected
      if (socket && socket.connected) {
        socket.emit("mark_super_admin_read", {
          threadId: chat.id
        });
      }

      // Fetch online status for the other user
      if (chat.other_user_id) {
        fetchUserOnlineStatus(chat.other_user_id);
      }

      // Clear unread count for this thread locally
      setUnreadCounts(prev => ({
        ...prev,
        [chat.id]: 0
      }));
    };
  
    const handleSendMessage = async () => {
      if ((!newMessage.trim() && !uploadedImageUrl && !uploadedFileUrl) || !selectedChat || isSendingMessage) return;
      
      // Check if thread ID is valid (numeric)
      if (!selectedChat.id || isNaN(Number(selectedChat.id))) {
        console.error("❌ Invalid thread ID:", selectedChat.id);
        alert(t("Invalid chat. Please select a valid conversation."));
        return;
      }
      
      console.log("🔄 Starting to send message");
      setIsSendingMessage(true);

      console.log("🔌 Socket status:", {
        socket: !!socket,
        connected: socket?.connected,
        readyState: socket?.readyState,
        id: socket?.id,
        transport: socket?.io?.engine?.transport?.name
      });
      
      // Manual connection test
      if (socket && !socket.connected) {
        console.log("🔄 Attempting manual socket connection...");
        socket.connect();
      }
      
      try {
        let messageContent = newMessage.trim() || "File shared"; // Always send text content
        let messageType = "text"; // Default to text

        // Determine message type based on what's uploaded
        if (uploadedFileUrl) {
          console.log("📄 File message detected:", { uploadedFileUrl, selectedFile: selectedFile?.name });
          messageType = "system"; // File message type
          console.log("📄 File message - content:", messageContent, "fileUrl:", uploadedFileUrl);
        } 
        else if (uploadedImageUrl) {
          messageType = "image"; // Image message type
          console.log("📷 Image message - content:", messageContent, "fileUrl:", uploadedImageUrl);
        } 
        else {
          messageType = "text"; // Text message
          console.log("📝 Text message content:", messageContent);
        }
        
        if (socket && socket.connected) {
          const tempId = `temp_${Date.now()}`;
          const messageData = {
            threadId: Number(selectedChat.id), // Ensure threadId is numeric
            content: messageContent,
            messageType: messageType,
            tempId: tempId,
            ...(uploadedImageUrl && { fileUrl: uploadedImageUrl }),
            ...(uploadedFileUrl && { 
              fileUrl: uploadedFileUrl, 
              fileName: selectedFile?.name,
              fileType: selectedFile?.type
            })
          };
          
          console.log("📤 Sending message via socket:", messageData);
          socket.emit("send_super_admin_message", messageData);
          
          // Mark message as sent immediately for UI feedback
          setMessageDeliveryStatus(prev => ({
            ...prev,
            [tempId]: {
              status: 'sent',
              timestamp: new Date().toISOString()
            }
          }));
          
          // Don't increment here - wait for server confirmation to avoid double counting
          console.log("📤 Message sent, waiting for server response with correct time");
          
          setNewMessage("");
          clearUploadedImage();
          clearUploadedFile();
        } else {
          console.log("⚠️ Socket not connected, cannot send message");
          // Don't clear the message so user can try again when socket reconnects
        }
      } catch (err) {
        console.error("❌ Error sending message:", err);
      } finally {
        setIsSendingMessage(false);
      }
    };
  
    const filteredChats = chatList.filter((chat) =>
      chat.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const filteredSuperAdmins = superAdmins.filter((admin) =>
      admin.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
      <Box sx={{ px: 1, mt: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            height: { xs: "auto", md: "80vh" },
            border: "2px solid #091E4224",
            borderRadius: 2,
            backgroundColor: "white",
          }}
        >
          {/* Sidebar */}
          <Box
            sx={{
              width: { xs: "100%", md: 380 },
              borderRight: "1px solid #e0e0e0",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
              }}
            >
              <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
                <CustomText
                  sx={{
                    ...textStyles.h1,
                    fontWeight: 500,
                    fontSize: "22px",
                    color: "#2C384C",
                  }}
                >
                  {t('roles.superAdmin')}
                </CustomText>
                {totalUnreadCount > 0 && (
                  <Box
                    sx={{
                      backgroundColor: "#006EC2",
                      color: "white",
                      borderRadius: "50%",
                      minWidth: "24px",
                      height: "24px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      fontWeight: "600",
                      fontFamily: "Poppins, sans-serif",
                      ml: 1,
                    }}
                  >
                    {getUnreadCountDisplay(totalUnreadCount)}
                  </Box>
                )}
              </Box>
              <IconButton
                sx={{ backgroundColor: "#003149", p: 0.2, borderRadius: "50%" }}
                onClick={() => {
                  if (showSuperAdminList) {
                    setShowSuperAdminList(false);
                  } else {
                    fetchSuperAdmins();
                    setShowSuperAdminList(true);
                  }
                }}
              >
                {showSuperAdminList ? (
                  <ArrowBack sx={{ color: "white" }} />
                ) : (
                  <Add sx={{ color: "white" }} />
                )}
              </IconButton>
            </Box>

            <Divider />

            {/* Search */}
            {!showSuperAdminList && (
              <Box sx={{ px: 1, py: 0.5 }}>
                <Box
                  sx={{
                    px: 0.5,
                    mt: 0.5,
                    py: 0.4,
                    borderRadius: 1,
                    height: 34,
                    border: "2px solid #091E4224",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <InputBase
                    placeholder={t('search_placeholder')}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{
                      ml: 0.5,
                      fontSize: 15,
                      color: "#939393",
                      fontWeight: 500,
                    }}
                  />
                  <SearchIcon sx={{ fontSize: 22, color: "#888", mr: 0.5 }} />
                </Box>
              </Box>
            )}

            {/* Super admin list or chat list */}
            <Box sx={{ flexGrow: 1, overflowY: "auto", px: 1 }}>
              <List>
                {showSuperAdminList ? (
                  isLoadingSuperAdmins ? (
                    // Loading skeleton for super admins
                    Array.from({ length: 3 }).map((_, index) => (
                      <ListItem key={index} sx={{ px: 1, py: 1 }}>
                        <ListItemAvatar>
                          <Skeleton variant="circular" width={40} height={40} />
                        </ListItemAvatar>
                        <ListItemText
                          primary={<Skeleton variant="text" width="70%" />}
                          secondary={<Skeleton variant="text" width="50%" />}
                        />
                      </ListItem>
                    ))
                  ) : (
                    filteredSuperAdmins.map((superAdmin) => (
                      <ListItem
                        key={superAdmin.id}
                        button
                        onClick={() => startNewChat(superAdmin)}
                        disabled={isCreatingThread}
                        sx={{
                          px: 1,
                          borderRadius: 2,
                          "&:hover": { backgroundColor: "#f5f5f5" },
                          "&:disabled": { opacity: 0.6 },
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar
                            src={superAdmin.profile_image || undefined}
                          >
                            {superAdmin.name?.charAt(0)}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={superAdmin.name}
                          secondary={superAdmin.email}
                          primaryTypographyProps={{
                            fontWeight: "600",
                            fontSize: "14px",
                            fontFamily: "Poppins, sans-serif",
                          }}
                          secondaryTypographyProps={{
                            fontSize: "13px",
                            color: "#5C5C5C",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        />
                      </ListItem>
                    ))
                  )
                ) : (
                  filteredChats.map((chat) => (
                    <ListItem
                      key={chat.id}
                      button
                      selected={selectedChat?.id === chat.id}
                      onClick={() => handleChatClick(chat)}
                      sx={{
                        px: 1,
                        borderRadius: 2,
                        backgroundColor:
                          selectedChat?.id === chat.id ? "#F0F9FF" : "transparent",
                        "&:hover": {
                          backgroundColor:
                            selectedChat?.id === chat.id ? "#F0F9FF" : "#f5f5f5",
                        },
                        position: "relative",
                        "&::before": selectedChat?.id === chat.id ? {
                          content: '""',
                          position: "absolute",
                          left: 0,
                          top: "50%",
                          transform: "translateY(-50%)",
                          height: "50%",
                          width: "4px",
                          backgroundColor: "#006EC2",
                          borderRadius: "2px",
                        } : {},
                      }}
                    >
                      <ListItemAvatar>
                        <Box sx={{ position: 'relative' }}>
                          <Avatar src={chat.avatar || undefined}>
                            {chat.name?.charAt(0)}
                          </Avatar>
                          {getOnlineStatusIndicator(chat.other_user_id)}
                        </Box>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                color: selectedChat?.id === chat.id ? "#006EC2" : "#100F0F",
                                fontFamily: "Poppins, sans-serif",
                              }}
                            >
                              {chat.name}
                            </Typography>
                          </Box>
                        }
                        secondary={
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            {chat.messageIcon === "image" && (
                              <Image sx={{ fontSize: 16, color: selectedChat?.id === chat.id ? "#006EC2" : "#666666" }} />
                            )}
                            {chat.messageIcon === "file" && (
                              <InsertDriveFile sx={{ fontSize: 16, color: selectedChat?.id === chat.id ? "#006EC2" : "#666666" }} />
                            )}
                            {chat.lastMessage && (
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  color: selectedChat?.id === chat.id ? "#006EC2" : "#666666",
                                  fontFamily: "Poppins, sans-serif",
                                  fontWeight: selectedChat?.id === chat.id ? "500" : "400",
                                }}
                              >
                                {chat.lastMessage}
                              </Typography>
                            )}
                          </Box>
                        }
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: "13px",
                            fontFamily: "Poppins, sans-serif",
                            color: selectedChat?.id === chat.id ? "#006EC2" : "#666666",
                            fontWeight: selectedChat?.id === chat.id ? "500" : "400",
                            opacity: selectedChat?.id === chat.id ? "1" : "1",
                          }}
                        >
                          {formatThreadTime(chat.lastMessageAt || chat.created_at)}
                        </Typography>
                        {unreadCounts[chat.id] > 0 && (
                          <Box
                            sx={{
                              backgroundColor: "#006EC2",
                              color: "white",
                              borderRadius: "50%",
                              minWidth: "20px",
                              height: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "11px",
                              fontWeight: "600",
                              fontFamily: "Poppins, sans-serif",
                            }}
                          >
                            {getUnreadCountDisplay(unreadCounts[chat.id])}
                          </Box>
                        )}
                      </Box>
                    </ListItem>
                  ))
                )}
              </List>
            </Box>
          </Box>

          {/* Right side */}
          <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
            {selectedChat && (
              <Box
                sx={{
                  px: 3,
                  py: 1.2,
                  borderBottom: "1px solid #e0e0e0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box sx={{ position: 'relative', mr: 2 }}>
                    <Avatar src={selectedChat.avatar} />
                    {getOnlineStatusIndicator(selectedChat.other_user_id)}
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "16px",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      {selectedChat.name}
                    </Typography>
                    {userOnlineStatus[selectedChat.other_user_id] && (
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: userOnlineStatus[selectedChat.other_user_id].isOnline ? "#4CAF50" : "#666",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      >
                        {userOnlineStatus[selectedChat.other_user_id].isOnline 
                          ? t('online') 
                          : `${t('offline')}`
                        }
                      </Typography>
                    )}
                  </Box>
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                  {totalUnreadCount > 0 && (
                    <IconButton 
                      onClick={markAllMessagesAsRead}
                      sx={{ 
                        backgroundColor: "#006EC2", 
                        color: "white",
                        "&:hover": { backgroundColor: "#0056b3" }
                      }}
                      title={t('mark_all_read')}
                    >
                      <DoneAll />
                    </IconButton>
                  )}
                  <IconButton onClick={() => setSelectedChat(null)}>
                    <Close />
                  </IconButton>
                </Box>
              </Box>
            )}

            {/* Messages */}
            <Box
              sx={{
                flexGrow: 1,
                px: 3,
                py: 2,
                display: "flex",
                flexDirection: "column",
                gap: 1,
                backgroundColor: "#FAFBFC",
                overflow: "hidden",
              }}
            >
              {!selectedChat && (
                <Box
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    color: "#5C5C5C",
                  }}
                >
                  <img 
                    crossOrigin="anonymous"
                    src={chatimage}
                    alt="chat" 
                    style={{ 
                      width: "200px", 
                      height: "200px", 
                      marginBottom: "20px",
                      opacity: 0.7 
                    }} 
                  />
                  <CustomText
                    sx={{
                      ...textStyles.h2,
                      color: "#2C384C",
                      textAlign: "center",
                      fontWeight: 600,
                      fontSize: "24px",
                      mb: 2,
                    }}
                  >
                    {t('super_admin_messages_title')}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.body1,
                      color: "#6C757D",
                      textAlign: "center",
                      fontSize: "16px",
                      mb: 1,
                    }}
                  >
                    {t('select_conversation_to_start')}
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.body2,
                      color: "#9CA3AF",
                      textAlign: "center",
                      fontSize: "14px",
                    }}
                  >
                    {t('select_conversation_to_start')}
                  </CustomText>
                </Box>
              )}

              {selectedChat && (
                <>
                  {/* Messages */}
                  <Box
                    sx={{
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      overflowY: "auto",
                      maxHeight: "calc(100vh - 200px)",
                      "&::-webkit-scrollbar": {
                        width: "6px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                        borderRadius: "3px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#c1c1c1",
                        borderRadius: "3px",
                        "&:hover": {
                          background: "#a8a8a8",
                        },
                      },
                    }}
                  >
  
                {messages.map((msg) => {
                  const isOwn = msg.sender_id === (socketUserId || userId);
                  
                  return (
                    <Box
                      key={msg.id}
                      sx={{
                        alignSelf: isOwn ? "flex-end" : "flex-start",
                        backgroundColor: isOwn ? "#006EC2" : "#F0F9FF",
                        color: isOwn ? "white" : "#2C3E50",
                        borderRadius: 2,
                        px: 2,
                        py: 0.5,
                        maxWidth: "70%",
                        mb: 1,
                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {msg.message_type === "text" ? (
                        <Typography
                          sx={{
                            fontSize: "13px",
                            fontWeight: 400,
                            fontFamily: "Poppins, sans-serif",
                            color: isOwn ? "white" : "#2C3E50",
                          }}
                        >
                          {msg.content !== "File shared" ? msg.content : ""}
                        </Typography>
                      ) : msg.message_type === "image" ? (
                        <Box>
                          <img
                          crossOrigin="anonymous"
                            src={(() => {
                              // Use file_url for image display
                              if (msg.file_url) {
                                // If file_url is already a full URL, use it directly
                                if (msg.file_url.startsWith('http://') || msg.file_url.startsWith('https://')) {
                                  return msg.file_url;
                                }
                                // If it's a relative path, add the base URL
                                return `${URL}${msg.file_url}`;
                              }
                              return '';
                            })()}
                            alt={msg.file_name || "Image"}
                            style={{ 
                              width: "120px", 
                              height: "120px",
                              borderRadius: "8px",
                              objectFit: "cover",
                              cursor: "pointer",
                              display: "block"
                            }}
                            onClick={() => {
                              const imageUrl = (() => {
                                if (msg.file_url) {
                                  if (msg.file_url.startsWith('http://') || msg.file_url.startsWith('https://')) {
                                    return msg.file_url;
                                  }
                                  return `${URL}${msg.file_url}`;
                                }
                                return '';
                              })();
                              if (imageUrl) {
                                window.open(imageUrl, '_blank');
                              }
                            }}
                          />
                          {msg.content && (
                            <Typography
                              sx={{
                                fontSize: "13px",
                                fontWeight: 400,
                                fontFamily: "Poppins, sans-serif",
                                color: isOwn ? "white" : "#2C3E50",
                                mb: 1,
                              }}
                            >
                              {msg.content !== "File shared" ? msg.content : ""}
                            </Typography>
                          )}
                        </Box>
                      ) : (msg.message_type === "file" || msg.message_type === "system") ? (
                        (() => {
                          // Use file_url for file display
                          let fileUrl = msg.file_url;
                          let fileName = msg.file_name || "Document";
                          
                          // Fallback to old format parsing if no file_url
                          if (!fileUrl) {
                            fileUrl = msg.content?.match(/\[File: .*? - (.*?)\]/)?.[1];
                            fileName = msg.file_name || msg.content?.match(/\[File: (.*?) -/)?.[1] || "Document";
                          }
                          
                          const fileExtension = fileName.split('.').pop()?.toLowerCase();
                          
                          return (
                            <Box>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  p: 1.5,
                                  backgroundColor: isOwn ? "rgba(255, 255, 255, 0.1)" : "#f5f5f5",
                                  borderRadius: "8px",
                                  border: isOwn ? "1px solid rgba(255, 255, 255, 0.2)" : "1px solid #e0e0e0",
                                  "&:hover": {
                                    backgroundColor: isOwn ? "rgba(255, 255, 255, 0.2)" : "#e0e0e0",
                                  }
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: 40,
                                    height: 40,
                                    borderRadius: "8px",
                                    backgroundColor: isOwn ? "rgba(255, 255, 255, 0.2)" : "#006EC2",
                                  }}
                                >
                                  {fileExtension === 'pdf' ? (
                                    <Typography sx={{ color: isOwn ? "white" : "white", fontSize: "16px", fontWeight: "bold" }}>PDF</Typography>
                                  ) : fileExtension === 'doc' || fileExtension === 'docx' ? (
                                    <Typography sx={{ color: isOwn ? "white" : "white", fontSize: "16px", fontWeight: "bold" }}>DOC</Typography>
                                  ) : fileExtension === 'txt' ? (
                                    <Typography sx={{ color: isOwn ? "white" : "white", fontSize: "16px", fontWeight: "bold" }}>TXT</Typography>
                                  ) : fileExtension === 'xls' || fileExtension === 'xlsx' ? (
                                    <Typography sx={{ color: isOwn ? "white" : "white", fontSize: "16px", fontWeight: "bold" }}>XLS</Typography>
                                  ) : fileExtension === 'ppt' || fileExtension === 'pptx' ? (
                                    <Typography sx={{ color: isOwn ? "white" : "white", fontSize: "16px", fontWeight: "bold" }}>PPT</Typography>
                                  ) : (
                                    <Description sx={{ color: isOwn ? "white" : "white", fontSize: 20 }} />
                                  )}
                                </Box>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography
                                    sx={{
                                      fontSize: "13px",
                                      fontWeight: 600,
                                      fontFamily: "Poppins, sans-serif",
                                      color: isOwn ? "white" : "#2C3E50",
                                      mb: 0.5,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    {fileName}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "11px",
                                      fontFamily: "Poppins, sans-serif",
                                      color: isOwn ? "rgba(255, 255, 255, 0.7)" : "#666",
                                      textTransform: "uppercase"
                                    }}
                                  >
                                    {fileExtension?.toUpperCase()} Document
                                  </Typography>
                                </Box>
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (fileUrl) {
                                      downloadFile(fileUrl, fileName);
                                    }
                                  }}
                                  sx={{
                                    width: 28,
                                    height: 28,
                                    backgroundColor: isOwn ? "rgba(255, 255, 255, 0.2)" : "#006EC2",
                                    color: isOwn ? "white" : "white",
                                    "&:hover": {
                                      backgroundColor: isOwn ? "rgba(255, 255, 255, 0.3)" : "#0056b3",
                                    }
                                  }}
                                >
                                  <Download sx={{ fontSize: 14 }} />
                                </IconButton>
                              </Box>
                              {msg.content && (
                                <Typography
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: 400,
                                    fontFamily: "Poppins, sans-serif",
                                    color: isOwn ? "white" : "#2C3E50",
                                    mb: 1,
                                  }}
                                >
                                  {msg.content !== "File shared" ? msg.content : ""}
                                </Typography>
                              )}
                            </Box>
                          );
                        })()
                      ) : (
                        <img
                        crossOrigin="anonymous"
                          src={msg.file_url ? (
                            msg.file_url.startsWith('http://') || msg.file_url.startsWith('https://') 
                              ? msg.file_url 
                              : `${URL}${msg.file_url}`
                          ) : ''}
                          alt={msg.file_name}
                          style={{ 
                            width: "120px", 
                            height: "120px", 
                            borderRadius: "8px", 
                            objectFit: "cover",
                            display: "block"
                          }}
                        />
                      )}
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.5 }}>
                        <Typography
                          sx={{
                            fontSize: "10px",
                            fontWeight: 400,
                            color: isOwn ? "rgba(255, 255, 255, 0.8)" : "#666666",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          {formatThreadTime(msg.created_at)}
                        </Typography>
                        {getMessageStatusIcon(msg.delivery_status || 'sent', isOwn, msg)}
                      </Box>
                    </Box>
                  );
                })}
                {/* Scroll anchor */}
                <div ref={messagesEndRef} />
              </Box>
  
              {/* File Upload Status */}
              {uploadedFileUrl || isUploadingFile ? (
                <Box
                  sx={{
                    px: 2,
                    py: 1,
                    borderTop: "1px solid #E8F4FD",
                    backgroundColor: "#F8F9FA",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 1.5,
                      border: "1px solid #E8F4FD",
                      borderRadius: "8px",
                      backgroundColor: "white",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flex: 1 }}>
                      {isUploadingFile ? (
                        <CircularProgress size={20} sx={{ color: "#006EC2" }} />
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 32,
                            height: 32,
                            borderRadius: "6px",
                            backgroundColor: "#006EC2",
                          }}
                        >
                          {(() => {
                            const fileExt = selectedFile?.name?.split('.').pop()?.toLowerCase();
                            if (fileExt === 'pdf') return <Typography sx={{ color: "white", fontSize: "12px", fontWeight: "bold" }}>PDF</Typography>;
                            if (fileExt === 'doc' || fileExt === 'docx') return <Typography sx={{ color: "white", fontSize: "12px", fontWeight: "bold" }}>DOC</Typography>;
                            if (fileExt === 'txt') return <Typography sx={{ color: "white", fontSize: "12px", fontWeight: "bold" }}>TXT</Typography>;
                            if (fileExt === 'xls' || fileExt === 'xlsx') return <Typography sx={{ color: "white", fontSize: "12px", fontWeight: "bold" }}>XLS</Typography>;
                            if (fileExt === 'ppt' || fileExt === 'pptx') return <Typography sx={{ color: "white", fontSize: "12px", fontWeight: "bold" }}>PPT</Typography>;
                            return <Description sx={{ color: "white", fontSize: 16 }} />;
                          })()}
                        </Box>
                      )}
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                          sx={{
                            fontSize: "13px",
                            fontWeight: 600,
                            color: "#2C3E50",
                            fontFamily: "Poppins, sans-serif",
                            mb: 0.5,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                          }}
                        >
                          {isUploadingFile ? t("Uploading file...") : selectedFile?.name}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "11px",
                            color: "#666",
                            fontFamily: "Poppins, sans-serif",
                            textTransform: "uppercase"
                          }}
                        >
                          {isUploadingFile ? "Please wait..." : `${selectedFile?.name?.split('.').pop()?.toUpperCase()} Document`}
                        </Typography>
                      </Box>
                    </Box>
                    {uploadedFileUrl && (
                      <IconButton
                        onClick={clearUploadedFile}
                        size="small"
                        sx={{ color: "#666" }}
                      >
                        <Close />
                      </IconButton>
                    )}
                  </Box>
                </Box>
              ) : null}

              {/* Image Preview */}
              {imagePreview || isUploadingImage ? (
                <Box
                  sx={{
                    px: 2,
                    py: 1,
                    borderTop: "1px solid #E8F4FD",
                    backgroundColor: "#F8F9FA",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 1,
                      border: "1px solid #E8F4FD",
                      borderRadius: "8px",
                      backgroundColor: "white",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      {isUploadingImage ? (
                        <CircularProgress size={16} sx={{ color: "#006EC2" }} />
                      ) : (
                        <Image sx={{ color: "#006EC2", fontSize: 20 }} />
                      )}
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#666",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      >
                        {isUploadingImage ? t("Uploading image...") : t("Image ready to send")}
                      </Typography>
                    </Box>
                    {uploadedImageUrl && (
                      <IconButton
                        onClick={clearUploadedImage}
                        size="small"
                        sx={{ color: "#666" }}
                      >
                        <Close />
                      </IconButton>
                    )}
                  </Box>
                  {imagePreview && !isUploadingImage && (
                    <Box
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img
                      crossOrigin="anonymous"
                        src={imagePreview}
                        alt="Preview"
                        style={{
                          width: "120px",
                          height: "120px",
                          borderRadius: "8px",
                          objectFit: "cover",
                          display: "block"
                        }}
                      />
                    </Box>
                  )}
                </Box>
              ) : null}

                  {/* Input */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      px: 2,
                      py: 1,
                      borderTop: "1px solid #E8F4FD",
                      backgroundColor: "#FAFBFC",
                      gap: 1,
                      flexShrink: 0,
                    }}
                  >
                <input
                  type="file"
                  accept="image/*,.pdf,.doc,.docx,.txt,.xls,.xlsx,.ppt,.pptx"
                  onChange={handleFileSelect}
                  style={{ display: "none" }}
                  id="file-upload"
                />
                <label htmlFor="file-upload">
                  <IconButton
                    component="span"
                    disabled={isUploadingImage || isUploadingFile}
                    sx={{ mr: 1 }}
                  >
                    {(isUploadingImage || isUploadingFile) ? (
                      <CircularProgress size={20} sx={{ color: "#006EC2" }} />
                    ) : (
                      <AttachFile sx={{ color: "#006EC2" }} />
                    )}
                  </IconButton>
                </label>
                <InputBase
                  placeholder={t('type_message_placeholder')}
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSendMessage();
                    }
                  }}
                  sx={{
                    flexGrow: 1,
                    border: "1px solid #E8F4FD",
                    borderRadius: "8px",
                    px: 2,
                    py: 1,
                    height: "40px",
                    fontSize: "14px",
                    fontFamily: "Poppins, sans-serif",
                    backgroundColor: "#FFFFFF",
                    "&:focus": {
                      borderColor: "#006EC2",
                      outline: "none",
                    },
                    "&::placeholder": {
                      color: "#7F8C8D",
                    },
                  }}
                />
                <IconButton
                  onClick={handleSendMessage}
                  disabled={isSendingMessage || isCreatingThread || (!newMessage.trim() && !uploadedImageUrl && !uploadedFileUrl)}
                  sx={{ ml: 1 }}
                >
                  {isSendingMessage || isCreatingThread ? (
                    <CircularProgress size={20} sx={{ color: "#006EC2" }} />
                  ) : (
                    <Send sx={{ color: "#006EC2" }} />
                  )}
                </IconButton>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };
  
  export default SuperAdminMessages;